import { useEffect, useState } from "react";

/** Narrower than this is a phone: the ramp cards, not the board. */
export const PHONE_MAX_WIDTH = 700;

const TOUCH_QUERY = "(hover: none) and (pointer: coarse)";

export interface Device {
  /** A phone-sized screen. */
  phone: boolean;
  /**
   * A finger, not a mouse: no hover, no right-click, and a press-and-drag is a scroll. The
   * board is read and tapped here, not dragged; changes go through the flight panel.
   */
  touch: boolean;
}

function read(): Device {
  if (typeof window === "undefined") return { phone: false, touch: false };
  return { phone: window.innerWidth < PHONE_MAX_WIDTH, touch: window.matchMedia?.(TOUCH_QUERY).matches ?? false };
}

/** What kind of screen this is, following a rotate or a resize. */
export function useDevice(): Device {
  const [device, setDevice] = useState(read);
  useEffect(() => {
    const update = () => setDevice((d) => {
      const n = read();
      return n.phone === d.phone && n.touch === d.touch ? d : n;
    });
    window.addEventListener("resize", update);
    const mq = window.matchMedia?.(TOUCH_QUERY);
    mq?.addEventListener?.("change", update);
    return () => {
      window.removeEventListener("resize", update);
      mq?.removeEventListener?.("change", update);
    };
  }, []);
  return device;
}
